import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapSettingsComponent } from './map-settings.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    MapSettingsComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    MapSettingsComponent
  ]
})
export class MapSettingsModule { }
